<template>
    <div class="homeWrap">
        <div style="padding:10px;" v-if="infoObj.app_state=='1'||infoObj.app_state=='2'">
            <span>审核：</span>
            <el-button size="mini" type="primary" @click="clickPass">通过</el-button>
            <el-button size="mini" type="danger" @click="clickRefuse">不通过</el-button>
        </div>
        <div class="msgBox">
            <ul>
                <li class="msgOneLine">
                    <div class="msgOneItem">
                        <span class="label">申请账号：</span>
                        <span class="text">{{infoObj.app_submit_user_id}}</span>
                    </div>
                    <div class="msgOneItem">
                        <span class="label">申请公司：</span>
                        <span class="text">{{infoObj.ces}}</span>
                    </div>
                    <div class="msgOneItem">
                        <span class="label">联系人姓名：</span>
                        <span class="text">{{infoObj.app_realname}}</span>
                    </div>
                </li>
                <li class="msgOneLine">
                    <div class="msgOneItem">
                        <span class="label">联系电话：</span>
                        <span class="text">{{infoObj.app_cellphone}}</span>
                    </div>
                    <div class="msgOneItem">
                        <span class="label">计划活动名称：</span>
                        <span class="text">{{infoObj.app_conference_name}}</span>
                    </div>
                    <div class="msgOneItem">
                        <span class="label">当前状态：{{infoObj.app_state}}</span>
                        <span class="" :class="{red:infoObj.app_state=='1'||infoObj.app_state=='2',green:infoObj.app_state=='3',orange_lighter:infoObj.app_state=='0'}">
                        {{infoObj.app_state |turnValToText('app_apply_result') }}</span>
                    </div>
                </li>
                <li class="msgOneLine">
                    <div class="msgOneItem">
                        <span class="label">提交时间：</span>
                        <span class="text">{{infoObj.app_submit_time}}</span>
                    </div>
                    <div class="msgOneItem">
                        <span class="label">备注：</span>
                        <span class="text">{{infoObj.app_conference_memo}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="tableBox">
            <div class="oneLine">审核历史：</div>
            <el-table size="mini" ref="multipleTable" border stripe :data="tableData" tooltip-effect="dark" style="width: 100%">
                <el-table-column label="申请账号">
                    <template slot-scope="scope">{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label="申请公司">
                    <template slot-scope="scope">{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label="联系人姓名">
                    <template slot-scope="scope">{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label="联系电话">
                    <template slot-scope="scope">{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label="计划活动名称">
                    <template slot-scope="scope">{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label="审核原因">
                    <template slot-scope="scope">{{ scope.row.name }}</template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
     import {
        ajaxPost,
        api
    } from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                infoObj:{},
                appId: '',
                tableData:[]
            }
        },
        computed:{
            adminId(){
               return  utils.getAdminId()
            }
        },
        methods: {
            getParams() {
                this.appId = this.$route.params.appId
            },
            refreshPage(){
                this.getDetail()
            },
            getDetail(){
                let arg = {
                    appId :this.appId,
                }
                let _this = this
                ajaxPost('/admin/getSystemInfo', arg).then(function(res) {
                    if(res.errorCode==200){
                        _this.infoObj=res.data
                    }
                }, function(res) {
                   
                })
            },
            ajaxFun(state){
                let _this = this
                let arg = {
                   appId :_this.appId,
                   "state":state,
                   "adminUserId":_this.adminId
                }
                ajaxPost('/admin/updateSystemInfo', arg).then(function(res) {
                    if(res.errorCode==200){
                      _this.$message({
                          message: "审核成功", //接口返回一个页面
                          type: 'success',
                          duration: 1000
                      });
                      
                    }else{
                        
                    }
                    _this.refreshPage()
                }, function(res) {
                 
                })
            },
            
            clickPass() {
                let _this = this
                if (confirm("确认同意该公司的申请吗？")) {
                    _this.ajaxFun("3")
                }
            },
            clickRefuse() {
                let _this = this
                this.$prompt('*请输入拒绝理由(必填项)', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '理由不能为空'
                }).then(({
                    value
                }) => {
                    // this.$message({
                    //     type: 'success',
                    //     message: '你的理由是: ' + value
                    // });
                     _this.ajaxFun("0")
                }).catch(() => {
                });
            },
        },
        mounted() {
            this.getParams()
            this.refreshPage()
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .homeWrap {
        padding: 5px 20px;

        .msgBox {
            padding:0 10px;
            .msgOneLine {
                display: flex;
                padding: 5px 0;

                .msgOneItem {
                    flex: 1;

                    .label {
                        display: inline-block;
                        color: #999;
                        width: 100px;
                    }

                    .text {
                        color: #000;
                    }
                }
            }
        }

        .tableBox {
            padding: 10px 0;

            .oneLine {
                padding: 10px;
                color: #999;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/customer/platUserAuth.vue